import React, { useState, useEffect, useRef } from 'react'
import PropType from 'prop-types'
import SVG from './../SVG'
import { getSVG, isDescendant } from './../../helpers/util'
import { FormattedMessage, injectIntl } from 'react-intl'

import './SearchField.scss'

const searchSVG = getSVG('search')

export const searchCriteria = [
  {
    title: <FormattedMessage
      id="Navbar.guest"
      defaultMessage="Guest"
    />,
    desc: <FormattedMessage
      id="Navbar.guestCriteria"
      defaultMessage="First Name, Last Name, Cabin No., Reservation No., Document No."
    />,
    id:'guest'
  },
  {
    title: <FormattedMessage
      id="Navbar.crew"
      defaultMessage="Crew"
    />,
    desc: <FormattedMessage
      id="Navbar.crewCriteria"
      defaultMessage="First Name, Last Name, Employee No."
    />,
    id:'crew'
  },
  {
    title: <FormattedMessage
      id="Navbar.visitor"
      defaultMessage="Visitor"
    />,
    desc: <FormattedMessage
      id="Navbar.visitorCriteria"
      defaultMessage="First Name, Last Name, Document No., DOB(yyyy-mm-dd)"
    />,
    id:'visitor'
  }
]
const SearchField = ({
  onChange,
  onKeyDown,
  value,
  placeholder,
  name,
  autoFocus,
  disabled,
  tabIndex,
  intl,
  shouldEnableSearchGuidelines,
  searchStateroomGuest,
  onTextSearch
}) => {
  const [inputValue, setValue] = useState(value)
  const [showGuidelines, setShowGuidelines] = useState(false)

  const isMounted = useRef(false)
  const onChangeHandler = event => {
    !disabled && isMounted.current && setValue(event.target.value)
    !disabled && isMounted.current && onChange(event)
  }

  const onKeyDownHandler = event => {
    !disabled && isMounted.current && onKeyDown(event, inputValue)
    setValue('')
    if(searchStateroomGuest){
    onTextSearch()
    }
  }

  const toggleDropdown = shouldClose => {
    let isDropdownActive = false
    if (shouldClose === 'true') {
      isDropdownActive = false
    } else if (shouldClose === 'false') {
      isDropdownActive = true
    } else {
      isDropdownActive = !showGuidelines
    }
    isMounted.current && setShowGuidelines(isDropdownActive)
  }
  useEffect(() => {
    isMounted.current = true
    return () => {
      isMounted.current = false
    }
  }, [])

  useEffect(() => {
    document.addEventListener('click', event => {
      if (event.target.textContent === intl.formatMessage({
        id: 'Navbar.searchGuidelines',
        defaultMessage: 'Search Guidelines'
      })) {
        toggleDropdown('false')
      } else if (!isDescendant(document.getElementById('guidelines'), event.target)) {
        toggleDropdown('true')
      }
    })
  }, [])

  useEffect(() => {
    if (value !== inputValue) {
      isMounted.current && setValue(inputValue)
    }
  }, [inputValue, value])

  return (
    <div className="SearchFieldContainer__div">
      <form onSubmit={onKeyDownHandler}>
      <div className="SearchField__input">
        <input
          name={name}
          value={inputValue}
          placeholder={placeholder}
          type="text"
          onChange={onChangeHandler}
          autoFocus={autoFocus} // eslint-disable-line
          tabIndex={tabIndex}
        />
        { shouldEnableSearchGuidelines && <div className="search-guidelines">
          <FormattedMessage
            id="Navbar.searchGuidelines"
            defaultMessage="Search Guidelines"
          />
        </div>}

        <SVG height={16} width={16}
             onClick={onKeyDownHandler}>
          {searchSVG}
        </SVG>
      </div>
      </form>

      {showGuidelines &&
      <div className="guidelines" id="guidelines">
        <div className="columns">
          <div className="column">
            <div className="guide-title">
              <FormattedMessage
                id="Navbar.searchCriteriaFor"
                defaultMessage="Search Criteria For"
              />
            </div>
          </div>
          <div className="column">
            <button className="delete is-pulled-right"
                    onClick={toggleDropdown}/>
          </div>
        </div>

        <div className="columns">
          {
            searchCriteria.map((item, i) => {
                return (<div className="column" key={i}>
                  <div><b>{item.title}</b></div>
                  <div>{item.desc}</div>
                </div>)
            })
          }
        </div>
      </div>}

    </div>
  )
}

SearchField.propTypes = {
  name: PropType.string,
  value: PropType.string,
  placeholder: PropType.string,
  onChange: PropType.func,
  onKeyDown: PropType.func,
  autoFocus: PropType.bool,
  onTextSearch:PropType.func,
  disabled: PropType.bool,
  searchStateroomGuest: PropType.bool,
  tabIndex: PropType.number,
  intl: PropType.object.isRequired,
  shouldEnableSearchGuidelines:PropType.bool
}

SearchField.defaultProps = {
  name: '',
  value: '',
  placeholder: '',
  onChange: () => {},
  onKeyDown: () => {},
  autoFocus: false,
  disabled: false,
  searchStateroomGuest:false,
  tabIndex: 0,
  shouldEnableSearchGuidelines: true
}

export default injectIntl(SearchField)
